import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMAT, EPAYMENT_TYPES_NAME, TITLE_INHERIT_STYLE } from "@constants";
import { EPaymentIframes } from "../interface/IPayment";
import { usePaymentBalance } from "./hook/usePaymentBalance";
import { PaymentBalanceIframe } from "./PaymentBalanceIframe";
import { format } from "date-fns";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { IPaymentMethod } from "@features/Payment/interface/IPaymentMethod";
import CardActions from "@mui/material/CardActions";

interface IParams {
    openedIframe?: EPaymentIframes;
    accountId: string;
    paymentMethodList: IPaymentMethod[];
    isNewPaymentProvider: boolean;
    setOpenedIframe(openedIframe?: EPaymentIframes): void;
    getPayerDetails(): void;
}

export const PaymentBalance = (props: IParams) => {
    const {
        openedIframe,
        setOpenedIframe,
        accountId,
        paymentMethodList,
        isNewPaymentProvider,
        getPayerDetails,
    } = props;
    const { balanceDetails, getCurrentBalanceState, getCurrentBalance } = usePaymentBalance({ accountId });

    const { t } = useTranslation(["payment", "common"]);

    const displayPaymentMethod =
        !getCurrentBalanceState.isLoading &&
        !getCurrentBalanceState.error &&
        balanceDetails &&
        balanceDetails.amount < 0;

    return (
        <Card elevation={2}>
            <CardHeader
                className="card-header card-header__right"
                title={t("payment:myCurrentBalance")}
                titleTypographyProps={TITLE_INHERIT_STYLE}
            />
            <CardContent>
                <div className="card-header__circle" />
                <HandleErrorAndLoading
                    error={getCurrentBalanceState.error}
                    isLoading={getCurrentBalanceState.isLoading}
                    retryFetch={getCurrentBalance}
                >
                    {balanceDetails && (
                        <Fragment>
                            <Typography align="center" color="primary" gutterBottom variant="h2">
                                {t("common:price", { price: balanceDetails.amount })}
                            </Typography>
                            {balanceDetails.amount < 0 && balanceDetails.paymentDate && (
                                <Typography align="center" color="primary" gutterBottom variant="normal">
                                    {t("payment:paidOn")}: {format(new Date(balanceDetails.paymentDate), DATE_FORMAT)}
                                </Typography>
                            )}
                            {balanceDetails.amount < 0 && (
                                <PaymentBalanceIframe
                                    amountToPay={balanceDetails.amount}
                                    getCurrentBalance={getCurrentBalance}
                                    getPayerDetails={getPayerDetails}
                                    isNewPaymentProvider={isNewPaymentProvider}
                                    openedIframe={openedIframe}
                                    paymentMethodList={paymentMethodList}
                                    setOpenedIframe={setOpenedIframe}
                                />
                            )}
                        </Fragment>
                    )}
                </HandleErrorAndLoading>
            </CardContent>
            {displayPaymentMethod && (
                <CardActions className="card-footer">
                    <Typography align="center" color="inherit" variant="normal">
                        {t("payment:paymentMethod")}: {EPAYMENT_TYPES_NAME.CREDIT_CARD}
                    </Typography>
                </CardActions>
            )}
        </Card>
    );
};
